import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useGetMyUser } from "@/user/query";
import { LoadingSpinner } from "./core/components/loading-spinner";
import { Stack } from "./core/components/ui/stack";
import { isAdmin } from "./user/utils";

const TestError = () => {
  const { data: user, isLoading } = useGetMyUser();

  useEffect(() => {
    // This will throw an error when the component mounts
    if (!!user && isAdmin(user?.role)) {
      throw new Error("This is a test error to verify the error boundary!");
    }
  }, [user]);

  if (isLoading) {
    return (
      <Stack className="h-full w-full items-center justify-center">
        <LoadingSpinner />
      </Stack>
    );
  }

  if (!!user && !isAdmin(user?.role)) {
    return <Navigate to="/" />;
  }

  return <div>This won't be rendered</div>;
};

export default TestError;
